import { Link, useLocation } from 'react-router-dom';
import { SparkleIcon } from './icons.jsx';
import LogoMark from './LogoMark.jsx';
import VoiceDictateFAB from './VoiceDictateFAB.jsx';

// Rutas en las que NO tiene sentido mostrar el FAB de dictado:
// el flujo de creacion ya esta abierto, o es el lector/admin.
const NO_FAB_PATTERNS = [/^\/draft(\/|$)/, /^\/generating(\/|$)/, /^\/story(\/|$)/, /^\/admin(\/|$)/];

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const showFab = !NO_FAB_PATTERNS.some((rx) => rx.test(pathname));

  return (
    <div className="flex min-h-full flex-col">
      <header className="sticky top-0 z-10 border-b border-brand-100 bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-2.5">
          <Link to="/" className="flex items-center gap-3">
            <LogoMark size={42} />
            <span className="text-xl font-bold leading-none text-brand-700 sm:text-2xl">
              La Fábrica de los Cuentos
            </span>
          </Link>
          {!isHome && (
            <Link
              to="/create"
              className="inline-flex items-center gap-1.5 rounded-full bg-brand-600 px-4 py-1.5 text-sm font-semibold text-white shadow hover:bg-brand-700"
            >
              <SparkleIcon size="1em" />
              Nuevo cuento
            </Link>
          )}
        </div>
      </header>
      <main className="flex-1">{children}</main>
      {showFab && <VoiceDictateFAB />}
    </div>
  );
}
